import qs from 'qs'
import { transUrl } from '../navigation/index'

// export const getTokenFromStorage = () => {
//   // 这是从全局存储获取的
//   if (
//     !(typeof voltaliStore === 'undefined') &&
//     voltaliStore &&
//     voltaliStore.getExtras
//   ) {
//     const extras = voltaliStore.getExtras()
//     return extras && extras.token
//   }
//   return null
// }

// export const getCostomInfoFromStorage = () => {
//   // 这是从全局存储获取的
//   if (
//     !(typeof voltaliStore === 'undefined') &&
//     voltaliStore &&
//     voltaliStore.getGlobalValue
//   ) {
//     const { customInfo } = voltaliStore.getGlobalValue('extras') || {}
//     return customInfo
//   }
//   return null
// }
// 类似/apps/$appId/res/95?token=$token'形式的路径参数值替换
// export const transUrl = (url, appId) => {
//   if (!url) return null
//   if (appId) {
//     return url.replace('$appId', appId).replace('$token', getTokenFromStorage())
//   }
//   return url.replace('$token', getTokenFromStorage())
// }

// 将接口返回的导航数据中的url转换为可跳转的url
export const transUrlIte = (nav, appId) => {
  let arr = null
  if (nav.children) {
    arr = nav.children.map((childNav) => transUrlIte(childNav, appId))
  }
  const url = transUrl(nav.url, appId)
  return {
    ...nav,
    url,
    matchUrl: url,
    children: arr,
  }
}

export const getTokenFromUrl = () => {
  const { token } = qs.parse(document.location.search.split('?')[1]) || {}
  if (!token) {
    return null
  }
  return token
}

export const getHostWithProject = () => {
  const index = document.location.href.indexOf('/apps')
  return document.location.href.slice(0, index)
}
